<template>
  <div>
    <!--v-show="show"-->
    <div align="right">
      <el-form :inline="true" class="style1">
        <el-form-item>
          <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t("general.add")}}
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px" :empty-text="$t('general.empty_data')" :row-key="row => row.id" :expand-row-keys="expandRowKeys" @expand-change="handleExpandChange">
      <!--  @row-click="rowClicked" -->

      <el-table-column type="expand">
        <template slot="header" slot-scope="scope">
          <i class="el-icon-caret-bottom"></i>
        </template>
        <template slot-scope="scope">
          <el-button class="el-icon-circle-plus-outline" type="text" @click="handleAdd(scope.row.noOfPrint)" style="float: right; margin-right: 8%;">
            {{$t("general.add")}}
          </el-button>

          <!-- <el-table-draggable handle=".handle" :scroll-sensitivity="450"> -->
          <el-table :data="listData" highlight-current-row border style="width: 100%; margin-top: 0px" :empty-text="$t('general.empty_data')">
            <!--  :row-key="rowNo" -->
            <!-- <el-table-column label="順番" align="center" width=50>
              <template slot-scope="scope">
                <div class="handle">
                <span>{{ scope.row.no }}</span></div>
              </template>
            </el-table-column> -->

            <el-table-column :label="$t('empIns13.employee_id')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.employee_id }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('empIns13.emp_name')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('empIns13.national')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.nation }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('empIns13.birthday')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.birthday }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('general.operation')" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
                  {{$t("general.edit")}}
                </el-button>
                <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
                  {{$t("general.delete")}}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- </el-table-draggable> -->
        </template>
      </el-table-column>

      <el-table-column :label="$t('companyInfo.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name1 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.date }}</span>
        </template>
      </el-table-column>

      <el-table-column label="人数" 　align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.noOfPrint }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" width="360">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEditParent(scope.$index, scope.row)">
            {{$t("general.edit")}}
          </el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDeleteParent(scope.$index, scope.row)">
            {{$t("general.delete")}}
          </el-button>
          <el-button size="mini" type="success" icon="el-icon-view" @click="printPDF(scope.$index, scope.row)">
            {{$t("general.print")}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!--adding new date-->

    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="39%" :before-close="handleClose">
      <el-form :model="parentForm" :rules="rules" ref="parentForm" label-width="9rem" class="demo-parentForm" size="medium" :label-position="labelPosition" style="width: 90%; margin-left: 5%; margin-right: 5%;">
        <el-input type="hidden" v-model="parentForm.id" />

        <el-form-item :label="$t('general.date')+':'" prop="date">
          <el-date-picker style="width:200px" v-model="parentForm.date" size="mini" value-format="yyyy-MM-dd" type="date">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('companyInfo.name')+':'" prop="company_id">
          <el-select v-model="parentForm.company_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')">
            <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addEmp13('parentForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('parentForm')" size="medium">{{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <!--edit date-->

    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="30%" :before-close="handleClose">
      <el-form :model="parentForm" :rules="rules" ref="parentForm" label-width="9rem" class="demo-parentForm" size="medium" :label-position="labelPosition" style="width: 90%; margin-left: 5%; margin-right: 5%;">
        <el-input type="hidden" v-model="parentForm.id" />

        <el-form-item :label="$t('general.date')+':'" prop="date">
          <el-date-picker v-model="parentForm.date" size="mini" value-format="yyyy-MM-dd" type="date">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('companyInfo.name')+':'">
          <el-input v-model="parentForm.name1" prefix-icon="el-icon-info" size=mini readonly></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="editEmp13('parentForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('parentForm')" size="medium">{{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <!--adding new emp-->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisibleEmp" width="70%" :before-close="handleClose">
      <el-form :model="listForm" status-icon :rules="rules" ref="listForm" label-width="210px" class="demo-listForm" size="medium" :label-position="labelPosition" style="width: 90%; margin-left: 5%; margin-right: 5%;">
        <el-input type="hidden" v-model="listForm.id" />
        <el-row :gutter=40>
          <el-col :span="12">
            <div>
              <el-form-item :label="$t('empIns13.employee_id')" prop="employee_id">
                <el-select v-model="listForm.employee_id" size="mini" no-data-text="$t('general.empty_data')" @change="employeeIdSelected" :placeholder="$t('general.select')" style="width: 100%;">
                  <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empIns13.emp_name')" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="listForm.name" size="mini" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns13.national')" prop="nation">
                <el-input prefix-icon="el-icon-info" v-model="listForm.nation" size="mini" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns13.branch')" prop="select">
                <el-input v-model="listForm.attach_no" size="mini" placeholder="123" prefix-icon="el-icon-edit" style="width: 80%;">
                </el-input>
                <el-button class="el-icon-info" type="text" @click="attachHint"></el-button>
              </el-form-item>

            </div>
          </el-col>
          <el-col :span="12">
            <div>

              <el-form-item :label="$t('empIns13.birthday')" prop="birthday">
                <el-input prefix-icon="el-icon-info" v-model="listForm.birthday" size="mini" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns13.emp_name_pho')" prop="name_rm">
                <el-input prefix-icon="el-icon-info" v-model="listForm.name_rm" size="mini" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns13.resident_card')" prop="resident_code">
                <el-input prefix-icon="el-icon-info" v-model="listForm.resident_code" size="mini" readonly></el-input>
              </el-form-item>

              <!-- <el-form-item :label="$t('empIns13.re_employ')" prop="select">
                <el-checkbox v-model="listForm.re_employ" size="mini"></el-checkbox>
                </el-checkbox>
                <el-input v-model="listForm.emp_insuranceID" v-if="listForm.re_employ" prefix-icon="el-icon-info" style="width: max-content;" size=mini readonly></el-input>
                <el-button class="el-icon-info" type="text" @click="firstHint"></el-button>
              </el-form-item> -->
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('listForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('listForm')" size="medium">{{$t("general.cancel")}}</el-button>
        <!-- <el-button style="width:120px" @click="resetForm('listForm')" size="medium">reset</el-button> -->

      </span>
    </el-dialog>

    <!--edit emp-->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdateEmp" width="70%" :before-close="handleClose">
      <el-form :model="listForm" status-icon :rules="rules" ref="listForm" label-width="210px" class="demo-listForm" size="medium" :label-position="labelPosition" style="width: 90%; margin-left: 5%; margin-right: 5%;">
        <el-input type="hidden" v-model="listForm.id" />
        <el-row :gutter=40>
          <el-col :span="12">
            <div>
              <el-form-item :label="$t('empIns13.employee_id')" prop="employee_id">
                <el-input prefix-icon="el-icon-info" v-model="listForm.employee_id" size="mini" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns13.emp_name')" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="listForm.name" size="mini" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns13.national')" prop="nation">
                <el-input prefix-icon="el-icon-info" v-model="listForm.nation" size="mini" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns13.branch')" prop="attach_no">
                <el-input v-model="listForm.attach_no" size="mini" placeholder="123" prefix-icon="el-icon-edit" style="width: 80%;">
                </el-input>
                <el-button class="el-icon-info" type="text" @click="attachHint"></el-button>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div>

              <el-form-item :label="$t('empIns13.birthday')" prop="birthday">
                <el-input prefix-icon="el-icon-info" v-model="listForm.birthday" size="mini" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns13.emp_name_pho')" prop="name_rm">
                <el-input prefix-icon="el-icon-info" v-model="listForm.name_rm" size="mini" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns13.resident_card')" prop="resident_code">
                <el-input prefix-icon="el-icon-info" v-model="listForm.resident_code" size="mini" readonly></el-input>
              </el-form-item>

              <!-- <el-form-item :label="$t('empIns13.re_employ')" prop="re_employ">
                <el-checkbox v-model="listForm.re_employ" size="mini"></el-checkbox>
                </el-checkbox>
                <el-input v-model="listForm.emp_insuranceID" v-if="listForm.re_employ" prefix-icon="el-icon-info" style="width: max-content;" size=mini readonly></el-input>
                <el-button class="el-icon-info" type="text" @click="firstHint"></el-button>
              </el-form-item> -->
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('listForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('listForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
// import ElTableDraggable from 'element-ui-el-table-draggable';
export default {
  // components: {
  //   ElTableDraggable,
  // },
  data() {
    return {
      pageSize: 6,
      currentPage: 1,
      total: 0,
      disablePage: false,

      labelPosition: "left",

      dialogVisible: false,
      dialogUpdate: false,
      dialogVisibleEmp: false,
      dialogUpdateEmp: false,

      expandRowKeys: [],

      tableData: [],
      listData: [],
      companyInfo: [],
      empList: [{
        id: "",
        employee_id: "",
        name: "",
        name_rm: "",
        birthday: "",
        emp_insuranceID: "",
        resident_code: "",
        nation: ""
      }],

      parentForm: {
        id: '',
        company_id: '',
        noOfPrint: '',
        date: '',
        company_code: '',
      },

      listForm: {
        id: "",
        employee_id: "",
        attach_no: "",
        re_employ: false,

        name: "",
        name_rm: "",
        birthday: "",
        emp_insuranceID: "",
        resident_code: "",
        nation: "",
      },

      rules: {
        company_id: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        date: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        employee_id: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
      },

    }
  },

  methods: {
    attachHint() {
      this.$notify.info({
        title: this.$t("empIns13.attachHintTitle"),
        message: this.$t("empIns13.attachHintMsg")
      });
    },
    firstHint() {
      this.$notify.info({
        title: this.$t("empIns13.firstHintTitle"),
        message: this.$t("empIns13.firstHintMsg")
      });
    },
    employeeIdSelected() {
      let postData = this.qs.stringify({
        employee_id: this.listForm.employee_id
      });
      this.axios({
        method: "post",
        url: "/ListEmpList",
        data: postData
      })
        .then(response => {
          this.empList1 = response.data;
          this.emp = this.empList1[0];

          if (this.emp.nation == "日本" || this.emp.nation == "JPN-日本") {
            this.$notify({
              title: '選択方法',
              message: '日本人の場合届出す必要がありません。',
              type: 'warning'
            });
          } else if (this.emp.nation != "日本" || this.emp.nation != "JPN-日本") {
            this.listForm.name = this.emp.name;
            this.listForm.name_rm = this.emp.name_rm;
            this.listForm.birthday = this.emp.birthday;
            this.listForm.emp_insuranceID = this.emp.emp_insuranceID;
            this.listForm.resident_code = this.emp.resident_code;
            this.listForm.nation = this.emp.nation;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    preview(row) {
      var uid = window.localStorage.getItem('LoginUserId');
      window.open(
        "/pdf/雇用保険の被保険者である外国人に係る届出-" + row.name1 + row.date + "-" + row.noOfPrint + ".pdf"

      );
    },

    printPDF(index, row) {
      let postData = this.qs.stringify({
        emp13ID: row.id
      });
      this.axios({
        method: "post",
        url: "/empIns13PDF",
        data: postData
      })
        .then(response => {
          this.$message({
            type: "success",
            message: this.$t("general.print_completed")
          });
          setTimeout(() => {
            this.preview(row);
          }, 300);
        })
        .catch(error => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed")
          });
        });
    },

    addEmp13(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            date: this.parentForm.date,
            noOfPrint: 0,
            company_id: this.parentForm.company_id
          });
          this.axios({
            method: "post",
            url: "/insertEmpIns13",
            data: postData
          })
            .then(response => {
              this.axios
                .post("/pageEmpIns13")
                .then(response => {
                  this.tableData = response.data;
                  this.currentPage = 1;
                  this.$message({
                    type: "success",
                    message: this.$t("general.add_completed")
                  });
                })
                .catch(error => {
                  this.$message({
                    type: "warning",
                    message: this.$t("general.add_failed")
                  });
                  console.log(error);
                });
              this.getPages();
              this.dialogVisible = false;
              this.resetForm(form);
              // console.log(response);
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleEditParent(index, row) {
      this.dialogUpdate = true;
      this.parentForm = Object.assign({}, row);
    },

    editEmp13(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.parentForm.id,
            date: this.parentForm.date,
            noOfPrint: this.parentForm.noOfPrint
          });
          this.axios({
            method: "post",
            url: "/updateEmpIns13",
            data: postData
          })
            .then(response => {
              this.handleCurrentChange();
              this.s1_cancel(form);
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed")
              });
              // console.log(response);
            })
            .catch(error => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed")
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleNoOfPrint(id, action) {
      let postData = this.qs.stringify({
        id: id,
        action: action,
      });
      this.axios({
        method: "post",
        url: "/updateNoOfPrint",
        data: postData
      })
        .then(response => {
          this.handleCurrentChange();
          this.$message({
            type: "success",
            message: this.$t("general.edit_completed")
          });
          // console.log(response);
        })
        .catch(error => {
          this.$message({
            type: "warning",
            message: this.$t("general.edit_failed")
          });
          console.log(error);
        });
    },

    handleDeleteParent(index, row) {
      // console.log(index, row);
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id
          });
          this.axios({
            method: "post",
            url: "/deleteEmpIns13",
            data: postData
          })
            .then(response => {
              this.getPages();
              this.currentPage = 1;
              this.$message({
                type: "success",
                message: this.$t("general.delete_completed")
              });
              // console.log(response);
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled")
          });
        });
    },

    handleAdd(no) {
      if (no > 19) {
        this.$message({
          type: "warning",
          message: "追加出来るのは20人までです。"
        });
      } else {
        this.dialogVisibleEmp = true
      }

    },

    addUser(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.emp.nation == "日本" || this.emp.nation == "JPN-日本") {
            this.$message({
              type: "error",
              message: "日本人が追加できません。"
            });
            return false;
          } else {
            let postData = this.qs.stringify({
              empIns13ID: this.listForm.empIns13ID,
              employee_id: this.listForm.employee_id,
              attach_no: this.listForm.attach_no,
              re_employ: this.listForm.re_employ
            });
            this.axios({
              method: "post",
              url: "/insertEmpIns13List",
              data: postData
            })
              .then(response => {
                this.getEmpList();
                this.handleNoOfPrint(this.listForm.empIns13ID, true);
                this.dialogVisibleEmp = false;
                this.resetForm(form)
              })
              .catch(error => {
                console.log(error);
              });
          }
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleEdit(index, row) {
      this.dialogUpdateEmp = true;
      this.listForm = Object.assign({}, row);
    },

    updateUser(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.listForm.id,
            empIns13ID: this.listForm.empIns13ID,
            employee_id: this.listForm.employee_id,
            attach_no: this.listForm.attach_no,
            re_employ: this.listForm.re_employ
          });
          this.axios({
            method: "post",
            url: "/updateEmpIns13List",
            data: postData
          })
            .then(response => {
              // this.handleCurrentChange();
              this.s1_cancel(formName);
              this.resetForm(formName);
              this.getEmpList();
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed")
              });
              // console.log(response);
            })
            .catch(error => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed")
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleDelete(index, row) {
      // console.log(index, row);
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id
          });
          this.axios({
            method: "post",
            url: "/deleteEmpIns13List",
            data: postData
          })
            .then(response => {
              this.getEmpList();
              this.handleNoOfPrint(this.listForm.empIns13ID, false);
              this.$message({
                type: "success",
                message: this.$t("general.delete_completed")
              });
              // console.log(response);
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled")
          });
        });
    },

    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(_ => {
          done();
          this.resetForm();
        })
        .catch(_ => { });
    },

    s1_cancel(formName) {
      this.dialogVisible = false;
      this.dialogUpdate = false;
      this.dialogVisibleEmp = false;
      this.dialogUpdateEmp = false;
      this.resetForm(formName);
    },

    resetForm(formName) {
      this.parentForm = {
        id: '',
        company_id: '',
        noOfPrint: '',
        date: '',
        company_code: '',
      },
        this.listForm = {
          id: "",
          employee_id: "",
          attach_no: "",
          re_employ: false,

          name: "",
          name_rm: "",
          birthday: "",
          emp_insuranceID: "",
          resident_code: "",
          nation: "",
        }
      this.$refs[formName].resetFields();
    },

    refreshData() {
      location.reload();
    },

    // rowClicked(row) {
    //   console.log("catch new table data on each from empIns13List")
    //   this.listForm.empIns13ID = row.id;
    //   console.log(this.listForm.empIns13ID)

    //   this.getEmpList();
    // },

    // rowNo() {
    //   for (let i = 0; i < this.listData.length; i++)
    //     this.listData[i].no = i + 1
    // },

    handleExpandChange(row, expandedRows) {
      const id = row.id;
      const lastId = this.expandRowKeys[0];
      // disable mutiple row expanded 
      this.expandRowKeys = id === lastId ? [] : [id];

      // this.rowClicked(row);
      console.log("catch new table data on each from empIns13List")
      this.listForm.empIns13ID = row.id;
      console.log(this.listForm.empIns13ID)

      this.getEmpList();
    },

    handleCurrentChange() {
      // console.log(`this.$t("general.current_page"): ${this.currentPage}`);
      let postData = this.qs.stringify({
        page: this.currentPage
      });
      this.axios({
        method: "post",
        url: "/pageEmpIns13",
        data: postData
      })
        .then(response => {
          this.tableData = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getPages() {
      this.axios
        .post("/pageEmpIns13")
        .then(response => {
          // console.log(response.data);
          this.show = true
          this.tableData = response.data;
        })
        .catch(error => {
          // this.show = false;
          // this.$message({
          //   type: 'error',
          //   message: '開発中です。'
          // });
          // console.log(error);
        });
      this.axios
        .post("/rowsEmpIns13")
        .then(response => {
          this.total = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getEmpList() {
      let postData = this.qs.stringify({
        emp13ID: this.listForm.empIns13ID
      });
      this.axios({
        method: "post",
        url: "/listEmpIns13All",
        data: postData
      })
        .then(response => {
          this.listData = response.data;
        })
        .catch(error => {
          this.show = false;
          this.$message({
            type: 'error',
            message: 'can\'t get list'
          });
          console.log(error);
        });
    }
  },

  created() {
    //get Pages


    this.getPages();

    //get Company List
    this.axios
      .post("/ListComInfo")
      .then((response) => {
        // console.log(response.data);
        this.companyInfo = response.data;
        console.log(this.companyInfo);
      })
      .catch((error) => {
        console.log(error);
      });


    //get Employee Name
    this.axios
      .post("/ListEmpListForInsNameChange")
      .then(response => {
        // console.log(response.data);
        this.empList = response.data;
        // console.log(this.empList);
      })
      .catch(error => {
        console.log(error);
      });

  }
}
</script>

<style scoped>
.style1 {
  margin-right: 100px;
  padding: 0px;
  text-align: right;
}

.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpIns13.vue